import { ToggleEvent } from "slotworks/graphics/elements/flexi-toggle";
import Layers from "slotworks/graphics/layers/layers";
import { Services } from "slotworks/services/services";
import AbstractToggleControl from "slotworks/smart-ui/controls/abstract/abstract-toggle-control";
import { Control } from "slotworks/smart-ui/controls/control";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";

export default class SoundfxToggleControl extends AbstractToggleControl implements Control {

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);

        this.toggle.setValue(!Services.sound.getSoundFxMuted());

        this.toggle.on(ToggleEvent.CHANGE, this.onChangeHandler);

        Services.sound.onMuteChange.add(() => this.muteUpdated());
    }

    protected onChangeHandler = (value: boolean) => {
        Services.sound.setSoundFxMute(value);

        if (Services.sound.getMusicMuted() && Services.sound.getSoundFxMuted()) {
            Services.sound.mute();
        } else {
            Services.sound.unmute();
        }
    }

    private muteUpdated() {
        const mute: boolean = !(Services.sound.getMuted() || Services.sound.getSoundFxMuted());
        this.toggle.setValue(mute);
    }
}
